<template lang="pug">
  .input(:class="classes")
    label.input__label
      |
    input.input__control(v-model.trim="inputValue", :placeholder="input.placeholder", ref="input", v-validate="input.validateRules", :name="index ? input.name + index : input.name", :readonly="disabled" type="text", @focus="handleFocus", @blur="handleBlur", @input="handleInput", @click="popupTriggerClickHandle")
    //- a.input__popup-trigger(v-if="input.hasPopup", href="#", @click.prevent="popupTriggerClickHandle")
      img.input__popup-trigger-pic(src="img/popup-trigger.svg")
    .input__error
      |{{index ? errors.first(input.name + index) : errors.first(input.name)}}
    //- .input__desc(v-if="input.hasDescription")
    //-   |Например
    //-   a.input__desc-link(href="#", @click.prevent)
    //-     |{{descLink}}
    //- .input__error(v-if="isError")
      |{{errors.first(input.name)}}


</template>

<script>
  import Inputmask from 'inputmask';
export default {

  inject: ['$validator'],
  props:{
    index:null,
    input: null,
    field: null,
    disabled: {
      default:false,
      required:false
    }
  },
  name: 'app-input',
  components: {
    
  },
  data() {
    return {
      // inputValue:'',
      isFocus: false
    }
  },
  mounted() {
    if (this.input.mask) {
        this.setMask();
    }
    
  },
  methods:{
    setMask() {
      const placeholder =
        this.input.maskPlaceholder != 'undefined'
            ? this.input.maskPlaceholder
            : '_';

      if (this.input.maskRegex) {
        new Inputmask({
            showMaskOnHover: false,
            placeholder,
            regex: this.input.mask
        }).mask(this.$refs.input);
      } else {
        new Inputmask(this.input.mask, {
            showMaskOnHover: false,
            placeholder
        }).mask(this.$refs.input);
      }
    },
    handleFocus(){
      this.$emit('handleFocus');
      this.isFocus = true;
    },
    handleBlur(){
      if(this.isEmpty) {
        this.isFocus = false;
      }
      this.$emit('handleBlur');
    },
    handleInput(e){
      // this.inputValue = e.target.value;
      // this.$emit('input', this.inputValue);
      // if(this.input.setter) {
      //   this.$store.dispatch(this.input.setter, this.inputValue);
      // }
      
    },
    popupTriggerClickHandle(){
      if(this.input.hasPopup) {
        this.$emit('togglePopup');
      }
    }
  },
  computed:{
    inputValue: {
      get() {
          return this.field;
      },

      set(field) {
          this.$emit('update:field', field);
          this.$emit('handleInput', field);
      }
    },
    isError() {
      if(this.index) {
        return this.errors.has(this.input.name + this.index);
      }
      return this.errors.has(this.input.name);
    },
    isEmpty() {
      if (this.inputValue) {
          return false;
      } else {
          return true;
      }
    },
    classes() {
      return {
        'is_status-focus': this.isFocus || !this.isEmpty,
        'is_status-error': this.isError,
        'is_status-valid': !this.isEmpty && !this.isError,
        'is_status-disabled': this.isDisabled
      };
    }
    // ...mapGetters({
    //   sportList: 'getSportList',
    //   sportTariffs: 'getSportTariffs',
    // })
  }
}
</script>

<style lang="scss">
  .input {
    position: relative;
    &__label {
      color: #7F7F7F;
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 5px;
      display: block;
    }
    
    &.is_status-focus {
      // .input__label {
      //   transform:translateY(20%) scale(.75);
      // }
      .input__control {
        padding-left: 0px;
        padding-bottom: 0px;
        border:2px solid transparent;
        border-bottom: 2px solid #aaabad;
      }
    }
    &.is_status-error {
      .input__control {
        border-bottom-color:#e61e33;
      }
    }
    &.is_status-valid {
      .input__control {
        // padding-left: 19px;
        // background-image: url('../assets/img/check.svg');
        // background-position: calc(100% - 20px) 50%;
        // background-repeat: no-repeat;
      }
    }
    &__popup-trigger {
      position: absolute;
      top: 10px;
      right: 17px;
      width: 30px;
      height: 30px;
      &-pic {
        width: 100%;
      }
    }
    &__pic {
      width: 42px;
    }
    &__label {
      // cursor: text;
      // position: absolute;
      // -webkit-transform-origin: left bottom;
      // transform-origin: left bottom;
      // margin-bottom: 0;
      // pointer-events: none;
      // left: 20px;
      // top: 0;
      // color: #8dbfc5;
      // -webkit-transform: translateY(120%) scale(1);
      // transform: translateY(120%) scale(1);
      // font-size: 20px;
      // line-height: 1;
      // z-index: 1;
      // -webkit-transition: -webkit-transform .2s linear;
      // transition: -webkit-transform .2s linear;
      // transition: transform .2s linear;
      // transition: transform .2s linear,-webkit-transform .2s linear;
    }
    &__control {
      display: block;
      width: 100%;
      font-weight: 400;
      line-height: 1.5;
      padding-right: 10px;
      padding-left: 1px;
      padding-bottom: 1px;
      height: 33px;
      font-size: 20px;
      border: 1px solid transparent;
      border-bottom:1px solid #aaabad;
      color: #000;
      outline:none;
      &:hover {
         // padding-left: 19px;
         padding-bottom: 0px;
        border-bottom: 2px solid #aaabad;
      }
      @include placeholder {
        color: #7F7F7F;
        font-size: 12px;
        line-height: 14px;
      }
    }
    &__error {
      color: #ff6464;
      font-size: 14px;
      padding-top: 4px;
      padding-left: 3px;
    }
    &__desc {
      margin-top: 3px;
      font-size: 12px;
      color: #808080;
    }
  }

</style>
